<div class="panel panel-default widget-support-tickets">
  <!--<div class="panel-heading">

  </div>-->
  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="container text-center" *ngIf="displayMode==1">
        <i class="fa fa-spinner fa-spin" style="font-size:48px;color:darkseagreen"></i> <p>{{'app.Loading' | translate}}</p>
      </div>
      <form #f="ngForm" *ngIf="displayMode==2"
            novalidate>

        <div class="row padding-sm-vr">
          <div class="row padding-sm-vr">
            <div class="col-sm-3">
              <div [ngClass]="{'has-success': (percenta.dirty || percenta.touched || f.submitted)  && percenta.valid, 'has-error' : (percenta.dirty || percenta.touched || f.submitted)  && percenta.invalid}">
                <label class="control-label" for="brandId-{{uniqueId}}">{{'Prcentage' | translate}}</label>
                <input type="number" name="percenta" [(ngModel)]="targetRequest.percentage" class="form-control" #percenta="ngModel"
                       [disabled]="viewMode || reviewMode|| targetRequest.type!=1" />
              </div>
            </div>

            <div class="col-sm-3">
              <div [ngClass]="{'has-success': (yearBased.dirty || yearBased.touched || f.submitted)  && yearBased.valid, 'has-error' : (yearBased.dirty || yearBased.touched || f.submitted)  && yearBased.invalid}">
                <label class="control-label" for="brandId-{{uniqueId}}">{{'Year Based On' | translate}}</label>
                <span class="ui-fluid">
                  <p-dropdown [options]="years"
                              styleClass="wid100" [disabled]="viewMode || reviewMode|| targetRequest.type!=1"
                              placeholder="Year"
                              emptyFilterMessage="No results found"
                              showClear="true"
                              name="yearBased" #yearBased="ngModel"
                              [(ngModel)]="targetRequest.yearBasedOn"
                              [filter]="true"></p-dropdown>
                </span>
                <div *ngIf="(yearBased.dirty || yearBased.touched || f.submitted)  && yearBased.invalid" class="jquery-validate-error help-block">
                  {{'app.RequiredField' | translate}}
                </div>
              </div>
            </div>
            <div class="col-sm-3">
              <div [ngClass]="{'has-success': (percentageBased.dirty || percentageBased.touched || f.submitted)  && percentageBased.valid, 'has-error' : (percentageBased.dirty || percentageBased.touched || f.submitted)  && percentageBased.invalid}">
                <label class="control-label" for="brandId-{{uniqueId}}">{{'Based On' | translate}}</label>
                <span class="ui-fluid">
                  <p-dropdown [options]="percentageBasedOn"
                              styleClass="wid100" [disabled]="viewMode || reviewMode|| targetRequest.type!=1"
                              placeholder="Percentage Based On"
                              emptyFilterMessage="No results found"
                              showClear="true"
                              name="percentageBased" #percentageBased="ngModel" optionLabel="name"
                              [(ngModel)]="targetRequest.percentageBasedOnModel"
                              [filter]="true"></p-dropdown>
                </span>
                <div *ngIf="(percentageBased.dirty || percentageBased.touched || f.submitted)  && percentageBased.invalid" class="jquery-validate-error help-block">
                  {{'app.RequiredField' | translate}}
                </div>
              </div>
            </div>
            <div class="col-sm-6" *ngIf="targetRequest.type==1">
              <div [ngClass]="{'has-success': (month.dirty || month.touched || f.submitted)  && month.valid, 'has-error' : (month.dirty || month.touched || f.submitted)  && month.invalid}">
                <label class="control-label">{{'Month' | translate}} </label>
                <ng-multiselect-dropdown [placeholder]="'Month'"
                                         [data]="months"
                                         name="month" [disabled]="viewMode || reviewMode"
                                         #month="ngModel"
                                         (onSelect)="onMonthChanged()"
                                         (onSelectAll)="onSelectAllMonths($event)"
                                         (onDeSelectAll)="onSelectAllMonths($event)"
                                         (onDeSelect)="onMonthChanged()"
                                         [(ngModel)]="selectedMonths"
                                         [settings]="dropdownSettings">
                </ng-multiselect-dropdown>
                <div *ngIf="(month.dirty || month.touched || f.submitted)  && month.invalid" class="jquery-validate-error help-block">
                  {{'app.RequiredField' | translate}}
                </div>
              </div>
            </div>

            <div class="col-sm-6">
              <div [ngClass]="{'has-success': (years.dirty || years.touched || f.submitted)  && years.valid, 'has-error' : (years.dirty || years.touched || f.submitted)  && years.invalid}">
                <label class="control-label" for="brandId-{{uniqueId}}">{{'Year' | translate}}</label>
                <span class="ui-fluid">
                  <p-dropdown [options]="years"
                              styleClass="wid100" [disabled]="viewMode || reviewMode|| targetRequest.type!=1"
                              placeholder="Year"
                              emptyFilterMessage="No results found"
                              showClear="true"
                              name="years"
                              [(ngModel)]="selectedYear"
                              [filter]="true"></p-dropdown>
                </span>
                <div *ngIf="(years.dirty || years.touched || f.submitted)  && years.invalid" class="jquery-validate-error help-block">
                  {{'app.RequiredField' | translate}}
                </div>
              </div>
            </div>
            <div class="col-sm-6" *ngIf="targetRequest.type==1">
              <div [ngClass]="{'has-success': (brand.dirty || brand.touched || f.submitted)  && brand.valid, 'has-error' : (brand.dirty || brand.touched || f.submitted)  && brand.invalid}">
                <label class="control-label">{{'Brands' | translate}} </label>
                <ng-multiselect-dropdown [placeholder]="'Brands'"
                                         [data]="itemBrands" [disabled]="viewMode || reviewMode"
                                         name="brand"
                                         #brand="ngModel"
                                         (onSelect)="onItmBrandsChanged()"
                                         (onSelectAll)="onSelectAllBrands($event)"
                                         (onDeSelectAll)="onSelectAllBrands($event)"
                                         (onDeSelect)="onItmBrandsChanged()"
                                         [(ngModel)]="selectedBrands"
                                         [settings]="dropdownSettings">
                </ng-multiselect-dropdown>
                <div *ngIf="(brand.dirty || brand.touched || f.submitted)  && brand.invalid" class="jquery-validate-error help-block">
                  {{'app.RequiredField' | translate}}
                </div>
              </div>
            </div>

          </div>

          <button class="btn  btn-cancel" type="button" (click)="apply()" *ngIf="!viewMode &&!reviewMode && targetRequest.type==1">{{'app.apply' | translate}}</button>&nbsp;
        </div>

        <div class="panel-body padding-sm-hr" *ngIf="(applyFilters || viewMode || reviewMode || selectedRequestId) &&  targetRequest.type==1">
          <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
            <div class="row">
              <div class="col-sm-12">

                <p-table #dt [value]="targetRequest.selectedBrands" [responsive]="true" sortMode="multiple" [paginator]="true" [rows]="pageSize">
                  <ng-template pTemplate="header">
                    <tr>
                      <th class="table-edit">{{'Brand Name' | translate}}</th>
                      <th class="table-edit" *ngFor="let m of targetRequest.selectedMonths">{{ m.name }}</th>

                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-item>
                    <tr *ngIf="targetRequest.selectedBrands.length>0 ">
                      <td>
                        <strong>{{item.name}}</strong>
                      </td>
                      <td *ngFor="let m of targetRequest.selectedMonths">
                        <input type="number" name="val-{{item.id}}-{{m.id}}" [ngModel]="getValue(item.id, m.id)" (ngModelChange)="setValue(item.id, m.id, $event)" class="form-control"
                               [disabled]="viewMode" />
                      </td>
                    </tr>


                    <tr *ngIf="targetRequest.selectedBrands.length==0">
                      <td colspan="3">{{'app.NoDataFound' | translate}}</td>
                    </tr>

                  </ng-template>
                  <ng-template pTemplate="footer">
                    <tr>
                      <td>
                        <strong>{{'Total' | translate}}</strong>
                      </td>
                      <td *ngFor="let m of targetRequest.selectedMonths">
                        <input type="number" name="{{m.id}}-tot" [ngModel]="getMonthTotal(m.id)" class="form-control"
                               disabled />
                      </td>
                    </tr>
                  </ng-template>
                </p-table>

              </div>

            </div>
          </div>
        </div>

        <div class="panel-body padding-sm-hr" *ngIf="(applyFilters || viewMode || reviewMode) &&  (targetRequest.type==2||targetRequest.type==3)">
          <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
            <div class="row">
              <div class="col-sm-12">

                <p-table #dt [value]="targetRequest.selectedOrgTypes" [responsive]="true" sortMode="multiple" [paginator]="true" [rows]="pageSize">
                  <ng-template pTemplate="header">
                    <tr>
                      <th class="table-edit">{{'Organization Type Name' | translate}}</th>
                      <th class="table-edit">{{'Item Name' | translate}}</th>
                      <th class="table-edit">{{'Brand Name' | translate}}</th>
                      <th class="table-edit" *ngFor="let m of targetRequest.selectedMonths">{{ m.name }}</th>

                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-org>
                    <ng-container *ngFor="let item of targetRequest.selectedItems">
                      <tr *ngIf="targetRequest.selectedOrgTypes.length>0 ">
                        <td>
                          <strong>{{org.name}}</strong>
                        </td>
                        <td>
                          {{item.name}}
                        </td>
                        <td>
                          {{item.itemBrandName}}
                        </td>
                        <td *ngFor="let m of targetRequest.selectedMonths">
                          <input type="number" name="val-{{org.id}}-{{item.id}}-{{m.id}}" [ngModel]="getOrgTypeItemValue(item.id,org.id, m.id)"
                                 (ngModelChange)="setOrgTypeItemValue(item.id,org.id, m.id, $event)" class="form-control"
                                 [disabled]="viewMode" />
                        </td>
                      </tr>
                      <tr *ngIf="targetRequest.selectedOrgTypes.length==0">
                        <td colspan="3">{{'app.NoDataFound' | translate}}</td>
                      </tr>
                    </ng-container>
                  </ng-template>
                  <ng-template pTemplate="footer">
                    <tr>
                      <td>
                        <strong>{{'Total' | translate}}</strong>
                      </td>
                      <td></td>
                      <td></td>
                      <td *ngFor="let m of targetRequest.selectedMonths">
                        <input type="number" name="{{m.id}}-tot" [ngModel]="getMonthTotal(m.id)" class="form-control"
                               disabled />
                      </td>
                    </tr>
                  </ng-template>
                </p-table>

              </div>

            </div>
          </div>
        </div>

        <div class="panel-body padding-sm-hr" *ngIf="(applyFilters || viewMode || reviewMode || selectedRequestId) &&  targetRequest.type==4">
          <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
            <div class="row">
              <div class="col-sm-12">

                <p-table #dt [value]="targetRequest.selectedHcos" [responsive]="true" sortMode="multiple" [paginator]="true" [rows]="pageSize">
                  <ng-template pTemplate="header">
                    <tr>
                      <th class="table-edit">{{'Hco Name' | translate}}</th>
                      <th class="table-edit">{{'item Name' | translate}}</th>
                      <th class="table-edit" *ngFor="let m of targetRequest.selectedMonths">{{ m.name }}</th>

                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-hco>
                    <ng-container *ngFor="let item of targetRequest.selectedItems">
                      <tr *ngIf="targetRequest.selectedHcos.length>0 ">
                        <td>
                          <strong>{{hco.name}}</strong>
                        </td>
                        <td>
                          {{item.name}}
                        </td>
                        <td *ngFor="let m of targetRequest.selectedMonths">
                          <input type="text" name="val-{{hco.id}}-{{item.id}}-{{m.id}}" [ngModel]="getHcoItemValue(item.id,hco.id, m.id)"
                                 (ngModelChange)="setHcoItemValue(item.id,hco.id, m.id, $event)" class="form-control"
                                 [disabled]="viewMode" />
                        </td>
                      </tr>
                      <tr *ngIf="targetRequest.selectedHcos.length==0">
                        <td colspan="3">{{'app.NoDataFound' | translate}}</td>
                      </tr>
                    </ng-container>
                  </ng-template>
                  <ng-template pTemplate="footer">
                    <tr>
                      <td>
                        <strong>{{'Total' | translate}}</strong>
                      </td>
                      <td></td>
                      <td *ngFor="let m of targetRequest.selectedMonths">
                        <input type="number" name="{{m.id}}-tot" [ngModel]="getMonthTotal(m.id)" class="form-control"
                               disabled />
                      </td>
                    </tr>
                  </ng-template>

                </p-table>

              </div>

            </div>
          </div>
        </div>

        <div class="panel-footer margin-left-20 margin-top-20 margin-left-37">
          <button class="btn  btn-cancel" type="button" (click)="back()">{{'app.cancel' | translate}}</button>&nbsp;
          <button class="btn  btn-save" (click)="save()" *ngIf="!viewMode && !reviewMode">{{'app.save' | translate}}</button>
          <button class="btn  btn-save" (click)="submit()" *ngIf="!viewMode && !reviewMode">{{'transactions.submit' | translate}}</button>
          <button class="btn  btn-save" (click)="approve()" *ngIf="reviewMode">{{'app.approve' | translate}}</button>
          <button class="btn  btn-save" (click)="reject()" *ngIf="reviewMode">{{'app.reject' | translate}}</button>

        </div>

      </form>
    </div>
  </div>
</div>

<div class="row col-sm-12 padding-sm-hr" *ngIf="displayMode==3">
  <div class="alert alert-danger alert-dark">
    <button type="button" class="close" data-dismiss="alert">×</button>
    {{'app.ServerError' |translate}}.
  </div>
</div>



